<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11 10.5C11 9.95 11.45 9.5 12 9.5C12.55 9.5 13 9.95 13 10.5C13 11.05 12.56 11.5 12 11.5C11.44 11.5 11 11.05 11 10.5Z"
      fill="CurrentColor"
    />
    <path
      d="M15 10.5C15 9.95 15.45 9.5 16 9.5C16.55 9.5 17 9.95 17 10.5C17 11.05 16.56 11.5 16 11.5C15.44 11.5 15 11.05 15 10.5Z"
      fill="CurrentColor"
    />
    <path
      d="M7 10.5C7 9.95 7.45 9.5 8 9.5C8.55 9.5 9 9.95 9 10.5C9 11.05 8.56 11.5 8 11.5C7.44 11.5 7 11.05 7 10.5Z"
      fill="CurrentColor"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M15.03 22.03L10.77 19.1899H7C3.56 19.1899 1.25 16.8799 1.25 13.4399V7.43994C1.25 3.99994 3.56 1.68994 7 1.68994H17C20.44 1.68994 22.75 3.99994 22.75 7.43994V13.4399C22.75 16.6199 20.77 18.84 17.75 19.15V20.5699C17.75 21.2199 17.4 21.8099 16.83 22.1099C16.57 22.2499 16.28 22.3199 16 22.3199C15.66 22.3199 15.32 22.22 15.03 22.03ZM2.75 7.42993V13.4299C2.75 16.0099 4.42 17.6799 7 17.6799H11C11.15 17.6799 11.29 17.7199 11.42 17.8099L15.87 20.77C15.98 20.84 16.08 20.81 16.13 20.78C16.18 20.75 16.26 20.6899 16.26 20.5599V18.4299C16.26 18.0199 16.6 17.6799 17.01 17.6799C19.59 17.6799 21.26 16.0099 21.26 13.4299V7.42993C21.26 4.84993 19.59 3.17993 17.01 3.17993H7C4.42 3.17993 2.75 4.84993 2.75 7.42993Z"
      fill="CurrentColor"
    />
  </svg>
</template>
